"use client";
import { useEffect } from "react";
import { focusItemCard } from "@/utils/focusItemCard";

interface RetailSlugInteractionsProps {
  pageType: "category" | "item";
}

export const RetailSlugInteractions = ({
  pageType,
}: RetailSlugInteractionsProps) => {
  useEffect(() => {
    if (pageType === "category") {
      focusItemCard();
    }
  }, [pageType]);

  // Intentionally effect-only: this component coordinates focus behavior and renders nothing.
  return null;
};
